export default __webpack_public_path__ + "a61a8a3d55506b026141daab634d28db.jpg";